export default __webpack_public_path__ + "static/media/trace2.a3944317.svg";